// =============================================
// SERVICIO DE GESTIÓN DE CONTRASEÑAS
// =============================================

import api from './api';

const passwordService = {
  // Establecer contraseña manual
  setPassword: async (userId, password, sendEmail = true) => {
    const response = await api.post('/passwords/set-password', {
      user_id: userId,
      password: password,
      send_email: sendEmail
    });
    return response.data;
  },

  // Generar contraseña temporal automática
  generateTemporary: async (userId, sendEmail = true) => {
    const response = await api.post('/passwords/generate-temporary', {
      user_id: userId,
      send_email: sendEmail
    });
    return response.data;
  },

  // Resetear contraseña
  resetPassword: async (userId) => {
    const response = await api.post(`/passwords/reset/${userId}`);
    return response.data;
  },

  // Verificar fuerza de contraseña
  checkStrength: async (password) => {
    const response = await api.post('/passwords/check-strength', {
      password: password
    });
    return response.data;
  },
};

export default passwordService;
